(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["AA-guide-theme-1"]) return;
  try {
    
(function () {
  function runDemo(btn, result) {
    if (!window.ButtonFeedback) return;
    btn.style.minWidth = btn.offsetWidth + 'px';
    window.ButtonFeedback.loading(btn);
    setTimeout(function () {
      if (result === 'error') {
        window.ButtonFeedback.error(btn);
      } else {
        window.ButtonFeedback.success(btn);
      }
    }, 1500);
  }

  document.querySelectorAll('[data-guide-demo-success]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'success'); });
  });

  document.querySelectorAll('[data-guide-demo-error]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'error'); });
  });

  document.querySelectorAll('[data-guide-demo-custom]').forEach(function (btn) {
    btn.addEventListener('click', function () { runDemo(btn, 'success'); });
  });

  document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pre = btn.previousElementSibling;
      navigator.clipboard.writeText(pre.textContent.trim()).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["AA-guide-theme-2"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-copy-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pre = btn.previousElementSibling;
      navigator.clipboard.writeText(pre.textContent.trim()).then(function () {
        var original = btn.textContent;
        btn.textContent = 'Copiado!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function () {
    var notification = document.querySelector('[data-cart-notification]');
    var hideTimer = null;

    function formatMoney(cents) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    // Lê o threshold vigente do DOM (atualizado a cada refresh do drawer) em vez de
    // cachear o valor do carregamento inicial da página, que fica obsoleto assim que
    // o cliente informa o CEP no meio da sessão.
    function getThreshold() {
      var el = document.querySelector('[data-free-shipping-threshold]');
      if (el) return parseInt(el.dataset.freeShippingThreshold, 10) || 0;
      return window.cartDrawerConfig?.freeShippingThreshold || 0;
    }

    function showNotification(cartTotal) {
      if (!notification) return;
      var threshold = getThreshold();
      if (threshold > 0) {
        var bar = notification.querySelector('[data-notification-bar]');
        var remainingEl = notification.querySelector('[data-notification-remaining]');
        var textEl = notification.querySelector('[data-notification-shipping-text]');
        var remaining = Math.max(0, threshold - cartTotal);
        var progress = Math.min(100, (cartTotal / threshold) * 100);
        if (bar) bar.style.width = progress + '%';
        if (remaining === 0) {
          if (textEl) textEl.innerHTML = '<strong>Você alcançou o frete grátis!</strong>';
        } else {
          if (remainingEl) remainingEl.textContent = formatMoney(remaining);
        }
      }
      notification.removeAttribute('hidden');
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        notification.setAttribute('hidden', '');
      }, 4000);
    }

    var closeBtn = notification?.querySelector('[data-close-cart-notification]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        notification.setAttribute('hidden', '');
        clearTimeout(hideTimer);
      });
    }

    document.addEventListener('cart:added', function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { showNotification(cart.total_price); })
        .catch(function () { showNotification(0); });
    });

    // Upsell add to cart
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-upsell-add]');
      if (!btn) return;
      if (btn.closest('[data-upsell-dragging]')) return;
      var variantId = btn.dataset.upsellAdd;
      if (variantId) window.CartManager?.add(variantId, { button: btn, action: 'open_drawer' });
    });

    // Upsell click protection after drag is handled by the inline script above

    // ─── Barra de frete grátis por CEP ─────────────────────────────────────
    var CEP_STORAGE_KEY = 'gfarma:shipping_region';
    var UF_TO_REGION = {
      AC: 'norte', AP: 'norte', AM: 'norte', PA: 'norte', RO: 'norte', RR: 'norte', TO: 'norte',
      AL: 'nordeste', BA: 'nordeste', CE: 'nordeste', MA: 'nordeste', PB: 'nordeste', PE: 'nordeste', PI: 'nordeste', RN: 'nordeste', SE: 'nordeste',
      DF: 'centro_oeste', GO: 'centro_oeste', MT: 'centro_oeste', MS: 'centro_oeste',
      ES: 'sudeste', MG: 'sudeste', RJ: 'sudeste', SP: 'sudeste',
      RS: 'sul', SC: 'sul',
      PR: 'pr'
    };

    function shippingContainer() {
      return document.querySelector('[data-shipping-container]');
    }

    function renderShippingMarkup(container, thresholdCents, cartTotal) {
      var barColor = container.dataset.barColor;
      var textColor = container.dataset.textColor;

      if (cartTotal >= thresholdCents) {
        container.innerHTML =
          '<p class="text-[12px] font-normal m-0 leading-[150%] mb-[8px]" style="color:' + textColor + ';">Você alcançou o frete grátis!</p>' +
          '<div class="flex items-center justify-between gap-[8px]">' +
            '<div class="h-[6px] w-full overflow-hidden rounded-full bg-[#E5E5E5]"><div class="h-full rounded-full" style="background-color:' + barColor + '; width:100%;"></div></div>' +
            '<span class="shrink-0 text-[12px] font-bold" style="color:' + textColor + ';">' + formatMoney(thresholdCents) + '</span>' +
          '</div>';
        return;
      }

      var remaining = thresholdCents - cartTotal;
      var progressPct = Math.min(100, (cartTotal / thresholdCents) * 100);
      container.innerHTML =
        '<div class="mb-[8px]"><p class="text-[12px] font-normal m-0 leading-[150%]" style="color:' + textColor + ';">Faltam <strong style="color:' + textColor + ';">' + formatMoney(remaining) + '</strong> para você ganhar frete grátis</p></div>' +
        '<div class="flex items-center justify-between gap-[8px]">' +
          '<div class="h-[6px] w-full overflow-hidden rounded-full bg-[#E5E5E5]"><div class="h-full rounded-full" style="background-color:' + barColor + '; width:' + progressPct + '%;"></div></div>' +
          '<span class="shrink-0 text-[12px] font-bold" style="color:' + textColor + ';">' + formatMoney(thresholdCents) + '</span>' +
        '</div>';
    }

    function applyRegion(region) {
      var container = shippingContainer();
      if (!container) return;

      var thresholds = {};
      try { thresholds = JSON.parse(container.dataset.regionThresholds || '{}'); } catch (e) {}
      var thresholdCents = thresholds[region] || 0;

      container.setAttribute('data-free-shipping-threshold', thresholdCents);

      if (thresholdCents <= 0) {
        container.setAttribute('hidden', '');
        return;
      }

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderShippingMarkup(container, thresholdCents, cart.total_price); })
        .catch(function () { renderShippingMarkup(container, thresholdCents, 0); });
    }

    // Reaplica a região salva sempre que o drawer é (re)renderizado pelo servidor,
    // já que o back-end não sabe qual CEP o visitante digitou.
    function applyStoredRegionIfPending() {
      var container = shippingContainer();
      if (!container || !container.querySelector('[data-shipping-cep-form]')) return;
      var storedRegion = localStorage.getItem(CEP_STORAGE_KEY);
      if (storedRegion) applyRegion(storedRegion);
    }

    function setCepError(message) {
      var errorEl = document.querySelector('[data-shipping-cep-error]');
      if (!errorEl) return;
      if (message) {
        errorEl.textContent = message;
        errorEl.removeAttribute('hidden');
      } else {
        errorEl.setAttribute('hidden', '');
      }
    }

    document.addEventListener('click', function (e) {
      var submitBtn = e.target.closest('[data-shipping-cep-submit]');
      if (!submitBtn) return;

      var form = submitBtn.closest('[data-shipping-cep-form]');
      var input = form?.querySelector('[data-shipping-cep-input]');
      var digits = (input?.value || '').replace(/\D/g, '');

      if (digits.length !== 8) {
        setCepError(form?.dataset.msgInvalid || 'CEP inválido.');
        return;
      }

      setCepError(null);
      submitBtn.disabled = true;

      fetch('https://viacep.com.br/ws/' + digits + '/json/')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.erro || !data.uf) {
            setCepError(form?.dataset.msgNotFound || 'CEP não encontrado.');
            return;
          }
          var region = UF_TO_REGION[data.uf];
          if (!region) {
            setCepError(form?.dataset.msgNotFound || 'CEP não encontrado.');
            return;
          }
          localStorage.setItem(CEP_STORAGE_KEY, region);
          applyRegion(region);
        })
        .catch(function () {
          setCepError(form?.dataset.msgError || 'Não foi possível verificar o CEP agora.');
        })
        .finally(function () {
          submitBtn.disabled = false;
        });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter') return;
      var input = e.target.closest('[data-shipping-cep-input]');
      if (!input) return;
      e.preventDefault();
      input.closest('[data-shipping-cep-form]')?.querySelector('[data-shipping-cep-submit]')?.click();
    });

    applyStoredRegionIfPending();

    var drawerContentEl = document.querySelector('[data-cart-drawer-content]');
    if (drawerContentEl) {
      new MutationObserver(applyStoredRegionIfPending).observe(drawerContentEl, { childList: true, subtree: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var nav = document.querySelector('[data-header-nav]');
    if (!nav) return;

    var navContainer = nav.parentElement;
    var triggers = nav.querySelectorAll('[data-nav-trigger]');
    var openMenu = null;

    function closeAll() {
      navContainer.querySelectorAll('[data-nav-menu]').forEach(function(m) {
        m.classList.add('hidden');
      });
      openMenu = null;
    }

    triggers.forEach(function(trigger) {
      var handle = trigger.getAttribute('data-nav-trigger');
      var menu = navContainer.querySelector('[data-nav-menu="' + handle + '"]');
      if (!menu) return;

      trigger.addEventListener('mouseenter', function() {
        if (openMenu && openMenu !== menu) {
          openMenu.classList.add('hidden');
        }
        menu.classList.remove('hidden');
        openMenu = menu;
      });

      trigger.addEventListener('focus', function() {
        closeAll();
        menu.classList.remove('hidden');
        openMenu = menu;
      });
    });

    nav.querySelectorAll('a:not([data-nav-trigger])').forEach(function(link) {
      link.addEventListener('mouseenter', closeAll);
    });

    navContainer.addEventListener('mouseleave', closeAll);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
